import * as navigation from 'Navigation';

export default class CanvasDefinitionTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Canvas',
      closeable: false,
      preferenceKey: 'canvas-definition',
    };
  }
}
